import { render } from "./ChatAttachment.vue?vue&type=template&id=6b75c368"
import script from "./ChatAttachment.vue?vue&type=script&lang=js"
export * from "./ChatAttachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__